import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import store from './store';
import { AxiosSetup } from './utils/helpers/api.helpers';
import { AuthProvider } from './Context/AuthContext';

// Initialize Axios
AxiosSetup();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Provider>

);

